import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';

export const StyledPopupFooterDiv = styled.div`
  ${rtl`
  display: flex;
  flex-direction: row-reverse;
  justify-content:space-around;
  position: fixed;
  z-index: 2;
  bottom: 0;
  padding: ${toRem(18)} ${toRem(24)} ${toRem(25)};
  width: 100%;
  background-color: ${theme.color.white};
  border-top: 1px solid ${theme.color['dark-gray-3']};

  .reset-btn {
    text-align: center;
    padding: 0;
    margin-top: ${toRem(22)};
    background: transparent;
    border: none;
  }
  @media ${theme.mediaQuery.tablet} {
    display: none;
  }
  @media ${theme.mediaQuery.mobileOnly} {
    flex-direction: row;
    justify-content: space-between;
    .reset-btn{
      padding-right: ${toRem(16)};
    }
    .done-btn{
      float: right;
      padding-right:${toRem(70)};
      padding-left:${toRem(70)};
    }
    .exact-btn{
      width:100%;
      height: ${toRem(52)};
    }
  }
`}
`;
